/**
 * AdminApp — routing shell for the /admin subtree.
 *
 * All admin routes live under /admin/*. When there is no token or the token is
 * rejected, we render <AdminLogin>. Otherwise we render <AdminLayout> which
 * wraps the individual pages (Dashboard / Staff / Tags).
 *
 * We use HashRouter-like nested paths under BrowserRouter — App.js mounts this
 * component behind the /admin/* wildcard.
 */
import { useEffect, useState } from "react";
import { Route, Routes, Navigate } from "react-router-dom";

import api, { clearToken, getToken } from "./api";
import AdminLogin from "./AdminLogin";
import AdminLayout from "./AdminLayout";
import Dashboard from "./pages/Dashboard";
import StaffList from "./pages/StaffList";
import StaffDetail from "./pages/StaffDetail";
import TagsList from "./pages/TagsList";
import TagDetail from "./pages/TagDetail";
import Settings from "./pages/Settings";

export default function AdminApp() {
    // "checking" | "unauth" | user-object
    const [state, setState] = useState(() => (getToken() ? "checking" : "unauth"));

    useEffect(() => {
        let alive = true;
        const t = getToken();
        if (!t) {
            setState("unauth");
            return;
        }
        api.get("/auth/me")
            .then((r) => {
                if (alive) setState(r.data);
            })
            .catch(() => {
                clearToken();
                if (alive) setState("unauth");
            });
        return () => {
            alive = false;
        };
    }, []);

    if (state === "checking") {
        return (
            <div className="min-h-screen flex items-center justify-center text-slate-500 text-sm">
                Caricamento…
            </div>
        );
    }

    if (state === "unauth") {
        return <AdminLogin onSuccess={(u) => setState(u)} />;
    }

    return (
        <Routes>
            <Route element={<AdminLayout user={state} onLogout={() => { clearToken(); setState("unauth"); }} />}>
                <Route index element={<Dashboard />} />
                <Route path="collaboratori" element={<StaffList />} />
                <Route path="collaboratori/:id" element={<StaffDetail />} />
                <Route path="tag" element={<TagsList />} />
                <Route path="tag/:code" element={<TagDetail />} />
                <Route path="impostazioni" element={<Settings />} />
                <Route path="*" element={<Navigate to="/admin" replace />} />
            </Route>
        </Routes>
    );
}
